import { Typography as MuiTypography, TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';

export type { TypographyProps };

export const Typography: React.ComponentType<TypographyProps> = styled(
  MuiTypography,
)<TypographyProps>(({ theme, color }) => ({
  ...(color === 'primary' && {
    color: theme.palette.colors.content.primary,
  }),
  ...(color === 'secondary' && {
    color: theme.palette.colors.content.secondary,
  }),
  ...(color === 'action' && {
    color: theme.palette.colors.content['action-primary'],
  }),
  ...(color === 'danger' && {
    color: theme.palette.colors.content['danger-primary'],
  }),
  // h1 variant styles
  '&.MuiTypography-h1, h1': {
    ...theme.typography['heading-s-accent'],
    fontVariantNumeric: 'lining-nums proportional-nums',
  },
}));
